import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay } from 'rxjs/operators';

import { LoadingStateService } from '@shared/services/loading-state.service';

@UntilDestroy()
@Directive({
  selector: '[miqLoadingIndicatorModeChange]',
  standalone: false,
})
export class LoadingIndicatorModeDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private loadingStateService: LoadingStateService
  ) {}

  ngOnInit() {
    this.loadingStateService.loading$
      .pipe(
        untilDestroyed(this),
        // workaround to Angular Debugging "Expression has changed after it was checked"
        delay(0)
      )
      .subscribe(this.onLoadingStateChange.bind(this));
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }

  private onLoadingStateChange(loading) {
    return !!loading ? this.viewContainer.createEmbeddedView(this.templateRef) : this.viewContainer.clear();
  }
}
